/**
 * components/knowledge/MonthTag.js — БҮЛЭГ АЛЬ САРЫНХ болохыг харуулна.
 *
 * ЯАГААД: «Ажлын байрны 365 хоногийн микро сургалт»-ын бүлэг нь сар бүрд
 * НЭГ (1-12). Жагсаалт, самбар, шинжилгээнд зөвхөн бүлгийн НЭР гардаг
 * байсан тул хэрэглэгч «энэ аль сарын сэдэв вэ», «энэ сарынх уу, өнгөрсөн
 * сарынх уу» гэдгийг ялгаж чаддаггүй байв (2026-09-30).
 *
 * ⚠ Сарыг бүлгийн НЭРЭНД шигтгэхгүй — тусдаа талбарт (`month_no` /
 *   `group_month`) хадгалагддаг тул энд ч тусдаа тэмдэг болж гарна.
 *   Нэрэнд бичвэл сараар шүүх, эрэмбэлэх боломж алдагдана.
 *
 * ⚠ ЭНЭ САР бол ТОДООР: хэрэглэгчийн хамгийн түгээмэл асуулт нь «одоо
 *   юу үзэх ёстой вэ» — түүнийг нүдээр шууд олох ёстой.
 */
import React from "react";

const MONTHS = [
  "1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар",
  "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар",
];

export const monthLabel = (m) => {
  const n = Number(m || 0);
  return n >= 1 && n <= 12 ? MONTHS[n - 1] : "";
};

export default function MonthTag({ month, style, size = "sm" }) {
  const n = Number(month || 0);
  if (!(n >= 1 && n <= 12)) return null;
  const now = new Date().getMonth() + 1;
  const isNow = n === now;
  return (
    <span
      title={isNow ? "Энэ сарын сэдэв" : `${MONTHS[n - 1]}-ын сэдэв`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: size === "sm" ? "0 6px" : "1px 8px",
        borderRadius: 999,
        fontSize: size === "sm" ? 10.5 : 11.5,
        fontWeight: 700,
        lineHeight: 1.7,
        whiteSpace: "nowrap",
        background: isNow ? "#0F6E56" : "#EEF1F5",
        color: isNow ? "#fff" : "#5B6472",
        border: `1px solid ${isNow ? "#0F6E56" : "#E1E6EC"}`,
        ...style,
      }}
    >
      <i
        className={"fas " + (isNow ? "fa-calendar-check" : "fa-calendar-alt")}
        style={{ fontSize: 9 }}
      />
      {MONTHS[n - 1]}
      {isNow ? " · энэ сар" : ""}
    </span>
  );
}
